import { NgModule } from '@angular/core';
// import { ScrollDispatchModule } from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import OverlayModule from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { SharedModule } from '@root/shared/shared.module';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { CalendarComponent } from '@root/component/calendar/calendar.component';

import { LoadingComponent } from '@root/component/loading/loading.component';
import { FormUploadComponent } from '@root/component/form-upload/form-upload.component';
import { UploadVoucherComponent } from '@root/component/upload-voucher/upload-voucher.component';
import { BaseMapComponent } from '@root/component/base-map/base-map.component';
import { MapComponent } from '@root/component/map/map.component';
import { MapService } from "@root/component/map/map.service";
import { OrderMoveHouseComponent } from "@root/component/order-move-house/order-move-house.component";
import { ShopAgreementComponent } from "@root/component/shop-agreement/shop-agreement.component";
import { QuarterSearchComponent } from "@root/component/search-components/search-time/quarter-search/quarter-search.component";
import { ReadOrdersComponent } from "@root/component/read-orders/read-orders.component";
import { SynchroniseCalendarComponent } from "@root/component/synchronise-calendar/synchronise-calendar.component";
import { SearchAccountComponent } from "@root/component/search-components/search-account/search-account.component";
import { InputWithErrorComponent } from "@root/component/input-with-error/input-with-error.component";
import { CurrencyDropdownComponent } from "@root/component/currency-dropdown/currency-dropdown.component";
import { UserDropdownComponent } from "@root/component/user-dropdown/user-dropdown.component";
import { SearchTimeComponent } from "@root/component/search-components/search-time/search-time.component";
// import { DaySearchComponent } from "@root/component/search-components/search-time/day-search/day-search.component";
import { MonthSearchComponent } from "@root/component/search-components/search-time/month-search/month-search.component";
import { YearSearchComponent } from "@root/component/search-components/search-time/year-search/year-search.component";
import { SetDateComponent } from "@root/component/set-date/set-date.component";
import { ClickDateComponent } from "@root/component/set-date/click-date/click-date.component";
import { RadioButtonComponent } from "@root/component/radio-button/radio-button.component";
import { ContinuousDateComponent } from "@root/component/set-date/continuous-date/continuous-date.component";
import { SearchGroupAndTypeComponent } from "@root/component/search-components/search-group-and-type/search-group-and-type.component";
import { SelectComponent } from "@root/component/select/select.component";
import { CalendarSelectSearchTimeComponent } from "@root/component/search-components/calendar-select-search-time/calendar-select-search-time.component";
import { CustomDatePickerComponent } from "@root/component/search-components/custom-date-picker/custom-date-picker.component";
import { LogoComponent } from "@root/component/logo/logo.component";
import { TujiaAutoReceiptComponent } from "@root/component/tujia-auto-receipt/tujia-auto-receipt.component";
import { ZhenguoSyncMessageComponent } from "@root/component/zhenguo-sync-message/zhenguo-sync-message.component";
import { SetDateMultipleMonthsComponent } from "@root/component/set-date-multiple-months/set-date-multiple-months.component";
import { ClickDatesComponent } from "@root/component/set-date-multiple-months/click-dates/click-dates.component";
import { ContinuousDatesComponent } from "@root/component/set-date-multiple-months/continuous-dates/continuous-dates.component";
import { SearchTimeService } from "@root/component/search-components/search-time.service";
import { AutoPopoverComponent } from "@root/router/house/component/multi-house-calendar/auto-popover/auto-popover.component";
import { InviteComponent } from "@root/component/invite/invite.component";
import { BlankPageComponent } from "@root/component/blank-page/blank-page.component";
import { SearchGroupAndTypeService } from "@root/component/search-components/search-group-and-type/search-group-and-type.service";
import { MultiSelectComponent } from "@root/component/search-components/multi-select/multi-select.component";
import { ImageMagnifierComponent } from "@root/component/image-magnifier/image-magnifier.component";
import { SearchQuickNewsComponent } from "@root/component/search-components/search-quick-news/search-quick-news.component";
import { SearchQuickNewsService } from "@root/component/search-components/search-quick-news/search-quick-news.service";
import { SearchDateAndHouseComponent } from "@root/component/search-components/search-date-and-house/search-date-and-house.component";
import { OneMonthCalendarComponent } from "@root/component/search-components/search-date-and-house/one-month-calendar/one-month-calendar.component";
import { SearchHousesWithGroupAndTypeComponent } from "@root/component/search-components/search-date-and-house/search-houses-with-group-and-type/search-houses-with-group-and-type.component";
import { SearchDateAndHouseService } from "@root/component/search-components/search-date-and-house/search-date-and-house.service";
import { SearchHouseInGroupAndTypeWithInputComponent } from "@root/component/search-components/search-house-in-group-and-type-with-input/search-house-in-group-and-type-with-input.component";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { TableFixedHeaderComponent } from "@root/component/table-fixed-header/table-fixed-header.component";
import { TableFixedHeaderService } from "@root/component/table-fixed-header/table-fixed-header.service";
import { TranslateQuarterService } from "@root/component/search-components/search-time/quarter-search/translate-quarter.service";
import { QrcodeDownloadComponent } from "@root/component/qrcode-download/qrcode-download.component";
import { CouponListComponent } from "@root/component/coupon-list/coupon-list.component";
import { SystemNotificationComponent } from "@root/component/system-notification/system-notification.component";
import { SearchPriceRangeComponent } from "@root/component/search-components/search-price-range/search-price-range.component";
import { SearchHouseInGroupAndTypeService } from "@root/component/search-components/search-house-in-group-and-type-with-input/search-house-in-group-and-type.service";
import { SearchItemsInGroupsComponent } from "@root/component/search-components/search-items-in-groups/search-items-in-groups.component";
import { ViewVoucherService } from "@root/component/view-voucher/view-voucher.service";
import { BaseImageUploadComponent } from '@root/component/base-image-upload/base-image-upload.component';
import { SimpleMultiSelectComponent } from './simple-multi-select/simple-multi-select.component'
import { RangeTimePickerComponent } from './range-time-picker/range-time-picker.component';
import {RangeFeePickerComponent} from './range-fee-picker/range-fee-picker.component';
import { StickyTableComponent } from './sticky-table/sticky-table.component';
import { RangeDatePickerComponent } from './range-date-picker/range-date-picker.component';
import { RangePickerComponent } from './range-picker/range-picker.component';
import { RangeQuarterComponent } from './range-picker/range-quarter/range-quarter.component';
import { CascadeRangePickerComponent } from './cascade-range-picker/cascade-range-picker.component';

const ThirdpartyModules = [
  NzSliderModule,
  NzAutocompleteModule
];

@NgModule({
  imports: [OverlayModule, SharedModule, ScrollingModule, ...ThirdpartyModules],
  declarations: [
    CalendarComponent,
    LoadingComponent,
    // MultiHouseCalendarComponent,

    // MonthCalendarV2Component,
    // MonthPriceCalendarV2Component,
    // YearCalendarV2Component,
    // ChartComponent,
    // PaymentDetailComponent,
    // MessageContainerComponent,
    // MessageComponent,
    FormUploadComponent,
    UploadVoucherComponent,
    BaseMapComponent,
    MapComponent,
    // OperateSidebarComponent,
    // ManualOrderComponent,
    // HousePriceComponent,
    // HostexPanelComponent,
    // HostexPriceComponent,
    // ChannelPanelComponent,
    // CtripPriceFormComponent,
    OrderMoveHouseComponent,
    ShopAgreementComponent,
    QuarterSearchComponent,
    ReadOrdersComponent,
    SynchroniseCalendarComponent,
    SearchAccountComponent,
    InputWithErrorComponent,
    CurrencyDropdownComponent,
    UserDropdownComponent,
    SearchTimeComponent,
    // DaySearchComponent,
    MonthSearchComponent,
    YearSearchComponent,
    SetDateComponent,
    ClickDateComponent,
    RadioButtonComponent,
    ContinuousDateComponent,
    SearchGroupAndTypeComponent,
    SelectComponent,
    CalendarSelectSearchTimeComponent,
    CustomDatePickerComponent,
    LogoComponent,
    TujiaAutoReceiptComponent,
    ZhenguoSyncMessageComponent,
    SetDateMultipleMonthsComponent,
    ClickDatesComponent,
    ContinuousDatesComponent,
    AutoPopoverComponent,
    InviteComponent,
    BlankPageComponent,
    MultiSelectComponent,
    ImageMagnifierComponent,
    SearchQuickNewsComponent,
    SearchDateAndHouseComponent,
    OneMonthCalendarComponent,
    SearchHousesWithGroupAndTypeComponent,
    SearchHouseInGroupAndTypeWithInputComponent,
    ViewVoucherComponent,
    // RelateHouseOrTypeComponent,
    TableFixedHeaderComponent,
    QrcodeDownloadComponent,
    CouponListComponent,
    SystemNotificationComponent,
    SearchPriceRangeComponent,
    SearchItemsInGroupsComponent,
    BaseImageUploadComponent,
    SimpleMultiSelectComponent,
    RangeQuarterComponent,
    RangePickerComponent,
    RangeTimePickerComponent,
    RangeDatePickerComponent,
    RangeFeePickerComponent,
    CascadeRangePickerComponent,
    StickyTableComponent,
  ],
  providers: [
    // MultiCalendarService,
    // MultiHouseCalendarService,
    // StatusService,
    // MessageService,
    MapService,
    SearchTimeService,
    SearchGroupAndTypeService,
    SearchQuickNewsService,
    SearchDateAndHouseService,
    // NoteV2Service,
    // RelateHouseOrTypeService,
    TableFixedHeaderService,
    TranslateQuarterService,
    SearchHouseInGroupAndTypeService,
    // PaymentDetailService,
    ViewVoucherService,
    // MESSAGE_DEFAULT_CONFIG_PROVIDER /** TODO: FIXME: Remove this */,
  ],
  entryComponents: [
    // MessageContainerComponent,
    // MessageComponent,
    OrderMoveHouseComponent,
    ShopAgreementComponent,
    ReadOrdersComponent,
    SynchroniseCalendarComponent,
    SetDateComponent,
    LogoComponent,
    TujiaAutoReceiptComponent,
    ZhenguoSyncMessageComponent,
    SetDateMultipleMonthsComponent,
    InviteComponent,
    SearchDateAndHouseComponent,
    ViewVoucherComponent,
    // RelateHouseOrTypeComponent,
    QrcodeDownloadComponent,
    CouponListComponent,
    SystemNotificationComponent,
  ],
  exports: [
    CalendarComponent,
    AutoPopoverComponent,
    LoadingComponent,
    // MultiHouseCalendarComponent,

    // MonthCalendarV2Component,
    // MonthPriceCalendarV2Component,
    // YearCalendarV2Component,
    // ChartComponent,
    // PaymentDetailComponent,
    FormUploadComponent,
    UploadVoucherComponent,
    BaseMapComponent,
    MapComponent,
    // OperateSidebarComponent,
    SearchAccountComponent,
    InputWithErrorComponent,
    CurrencyDropdownComponent,
    UserDropdownComponent,
    SearchTimeComponent,
    SetDateComponent,
    SetDateMultipleMonthsComponent,
    RadioButtonComponent,
    SearchGroupAndTypeComponent,
    SelectComponent,
    CalendarSelectSearchTimeComponent,
    CustomDatePickerComponent,
    LogoComponent,
    BlankPageComponent,
    MultiSelectComponent,
    ImageMagnifierComponent,
    SearchQuickNewsComponent,
    SearchHousesWithGroupAndTypeComponent,
    TableFixedHeaderComponent,
    QrcodeDownloadComponent,
    CouponListComponent,
    SystemNotificationComponent,
    SearchPriceRangeComponent,
    SearchHouseInGroupAndTypeWithInputComponent,
    MonthSearchComponent,
    // DaySearchComponent,
    SearchItemsInGroupsComponent,
    BaseImageUploadComponent,
    SimpleMultiSelectComponent,
    RangePickerComponent,
    RangeTimePickerComponent,
    RangeDatePickerComponent,
    RangeFeePickerComponent,
    CascadeRangePickerComponent,
    StickyTableComponent,
  ],
})
export class ComponentModule {
  constructor() {
    console.log('[Init Done]: ComponentModule');
  }
}
